import {ReactNode, useMemo} from 'react';
import {useSearchParams} from 'next/navigation';

export interface ISortingOption {
    comment: string;
    isApplied: boolean;
    param: string;
    title: string | ReactNode;
}
interface IUseSortingControl {
    options: ISortingOption[];
    sortKey?: string;
    sortingValues: Record<string, string>;
    defaultValue: string;
}

export const useSortingControl = ({options, sortKey = 'sort', sortingValues, defaultValue}: IUseSortingControl) => {
    const search = useSearchParams();
    const sort = search.get(sortKey) || defaultValue;

    if (!options.find((item) => item.param !== defaultValue)) {
        throw new Error('useSortingControl: значение по умолчанию должны быть передано в options');
    }

    const sortingList = useMemo(
        () =>
            Object.values(sortingValues).includes(sort)
                ? options.map((option) => ({...option, isApplied: option.param === sort}))
                : options,
        [options, sort, sortingValues],
    );

    return {sortingList};
};
